import styles from "./Index.module.css"

//Components
import PageHeader from "../../../PageHeader/PageHeader";
import PageInfo from "../../components/PageInfo";
import PageState from "../../components/PageState";


export default function DetViTrorPaa() {

    return(
        <PageState
            pageName="DetViTrorPaa"
            render={({ data, sections, sectionNames }) => {    
                const {Sec1,Sec2,Sec3} = data

                return (
                    <div>
                        <PageHeader image={data.PageHeader.imageUrl} title={data.PageHeader.title} description={data.PageHeader.text} sections={sections} sectionNames={sectionNames}> </PageHeader>
                        <section id={Sec1.secId} className={styles.sec1}>
                            <PageInfo 
                                title={Sec1.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }}/>} 
                                version={"v5"}/>
                        </section>
                        <section id={Sec2.secId}>
                            <div className={styles.fundamentet}>
                                <div className={styles.backgroundImage} style={{ backgroundImage: `url(${Sec2.imageUrl})` }}></div>
                                <div className={styles.fundamentetInfo}>
                                    <h1>{Sec2.header}</h1>
                                    <div dangerouslySetInnerHTML={{ __html: Sec2.text }}/>
                                </div>
                            </div>
                            <div>
                                <div className={styles.listItem1}>
                                    <h2 className={styles.number}>01</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item1.title}</h2>
                                        <div className={styles.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item1.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem2}>
                                    <h2 className={styles.number}>02</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item2.title}</h2>
                                        <div className={styles.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item2.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem1}>
                                    <h2 className={styles.number}>03</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item3.title}</h2>
                                        <div className={styles.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item3.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem2}>
                                    <h2 className={styles.number}>04</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item4.title}</h2>
                                        <div className={styles.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item4.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem1}>
                                    <h2 className={styles.number}>05</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item5.title}</h2>
                                        <div className={styles.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item5.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem2}>
                                    <h2 className={styles.number}>06</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item6.title}</h2>
                                        <div className={styles.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item6.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem1}>
                                    <h2 className={styles.number}>07</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item7.title}</h2>
                                        <div className={styles.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item7.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem2}>
                                    <h2 className={styles.number}>08</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item8.title}</h2>
                                        <div className={styles.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item8.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem1}>
                                    <h2 className={styles.number}>09</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item9.title}</h2>
                                        <div className={styles.listItemText1} dangerouslySetInnerHTML={{ __html: Sec2.item9.text }}/>
                                    </div>
                                </div>
                                <div className={styles.listItem2}>
                                    <h2 className={styles.number}>10</h2>
                                    <div>
                                        <h2 className={styles.listItemTitle}>{Sec2.item10.title}</h2>
                                        <div className={styles.listItemText2} dangerouslySetInnerHTML={{ __html: Sec2.item10.text }}/>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id={Sec3.secId}>
                            <div className={styles.vedtagter}>
                                <h1>
                                    {Sec3.header}
                                </h1>
                                <p style={{textAlign: 'start'}}>
                                    {<div dangerouslySetInnerHTML={{ __html: Sec3.text }}/>}
                                </p>
                            </div>
                        </section>
                    </div>
                );
            }
        }/>
    );
}